import React from "react";
import { Button, ButtonProps, CircularProgress } from "@mui/material";

interface StandardButtonProps extends ButtonProps {
  loading?: boolean;
}

export const StandardButton: React.FC<StandardButtonProps> = ({
  variant = "contained",
  color = "primary",
  size = "large",
  loading,
  disabled,
  startIcon,
  endIcon,
  children,
  sx,
  ...rest
}) => {
  const sizeStyles = {
    small: {
      py: 1,
      px: 2,
      fontSize: "0.9rem",
      "& .MuiSvgIcon-root": { fontSize: "1.1rem" },
    },
    medium: {
      py: 1.5,
      px: 3,
      fontSize: "1rem",
      "& .MuiSvgIcon-root": { fontSize: "1.25rem" },
    },
    large: {
      py: 2,
      px: 4,
      fontSize: "1.1rem",
      "& .MuiSvgIcon-root": { fontSize: "1.4rem" },
    },
  };

  return (
    <Button
      variant={variant}
      color={color}
      size={size}
      disabled={disabled || loading}
      startIcon={startIcon}
      endIcon={endIcon}
      sx={{
        fontWeight: 600,
        letterSpacing: "0.01em",
        ...sizeStyles[size || "large"],
        ...sx,
      }}
      {...rest}
    >
      {loading ? <CircularProgress size="14px" /> : children}
    </Button>
  );
};
